import { ColGroup, EditDialog, Radio } from '@104ha/base-ui';
import { CompanySelect } from 'open-api-client/src/components/company-select';
import { PrivilegeGrid } from 'open-api-client/src/components/privilege-grid';
import { Space } from 'open-api-client/src/components/space';
import { formError, privilageDialogHeight, privilageDialogWidth } from 'open-api-client/src/page/api-permission/const';

const inputs = {
	mgtScope: null,
	companies: null,
	privilege: null,
};

type Keys = keyof typeof inputs;

type DataObeject = {
	accountStatus: number;
	apiNumber: number;
	cmpNumber: string;
	id: number;
	idx: number;
	mgtScope: number;
	privilege: {
		apiName: string;
		apiColumns: string[];
	}[];
	companies: any[];
	userAccount: string;
	userName: string;
	userIp: string;
	userIpType: number;
};

class EditPrivilegeDialog extends EditDialog<
	{ id?: number; rowData?: DataObeject },
	{
		mgtScope: number;
		data: {};
	}
> {
	static defaultProps = {
		...EditDialog.defaultProps,
		title: '編輯API使用者連接帳號',
		width: privilageDialogWidth,
		height: privilageDialogHeight,
		loadApi: '/api/manage/privilege/detail',
		api: '/api/manage/privilege/update',
		errCode: formError,
		successMsg: '編輯權限完成',
		okText: '確定修改',
	};

	constructor(props: any) {
		super(props);
		this.state = {
			...this.state,
			mgtScope: this.props.rowData?.mgtScope || 1,
		};
	}

	inputs: {
		[key in Keys]?: {
			getValue: () => any;
			setState: (params: any) => any;
		} | null;
	} = inputs;

	renderBody() {
		const { userAccount, userName, userIp, userIpType, privilege, companies } = Object.assign(
			{},
			this.props.rowData,
			this.state.data
		);
		const { mgtScope } = this.state;
		const readOnly = false;

		return (
			<div>
				<table className={'table table-view'}>
					<ColGroup cols={[30, 70]} />
					<tbody>
						<tr>
							<th>API登入帳號</th>
							<td>{userAccount}</td>
						</tr>
						<tr>
							<th>帳號名稱</th>
							<td>{userName}</td>
						</tr>
						<tr>
							<th>連接IP位址限制</th>
							<td>
								{userIp}
								{userIpType === 1 ? ' ( IPV4 ) ' : ' ( IPV6 ) '}
							</td>
						</tr>
						<tr>
							<th>可存取公司</th>
							<td>
								<Radio
									{...{
										ref: (ele: any) => (this.inputs.mgtScope = ele),
										validate: { required: true },
										data: { 1: '全部公司', 2: '部分公司' },
										initValue: mgtScope,
										onUpdate: (v) => {
											this.setState({ mgtScope: v });
										},
										readOnly,
									}}
								/>
							</td>
						</tr>
						<tr>
							<th>
								<Space />
							</th>
							<td>
								{mgtScope === 2 && (
									<CompanySelect
										ref={(ele: any) => (this.inputs.companies = ele)}
										validate={{
											required: true,
										}}
										initValue={companies}
										readOnly={readOnly}
									/>
								)}
							</td>
						</tr>
					</tbody>
				</table>
				<PrivilegeGrid
					privilege={privilege}
					readOnly={false}
					ref={(ele: any) => (this.inputs.privilege = ele)}
				/>
			</div>
		);
	}
}
export { EditPrivilegeDialog };
